module.exports = __webpack_public_path__ + "img/ic_parking.f9ed1ba6.png";